// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stat from '@infrastructure/shared/constant'
// ** Axios Imports
import axios from 'axios'

export const getGrade = createAsyncThunk('appNilaiAp/getGrade', async params => {
  const response = await axios.get(stat.URL_GRADE_KINDERGATEN, { params })
  return {
    data: response.data
  }
})

export const getGradeKelas = createAsyncThunk('appNilaiAp/getGradeKelas', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_KELAS + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getAspekPerkembangan = createAsyncThunk('appNilaiAp/getAspekPerkembangan', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_ASPEK_PERKEMBANGAN + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getAspekPerkembanganMember = createAsyncThunk('appNilaiAp/getAspekPerkembanganMember', async (id_kelas, {params, getState })  => {
  const add_url = "member/"
  console.log(stat.URL_ASPEK_PERKEMBANGAN + add_url + id_kelas)
  const response = await axios.get(stat.URL_ASPEK_PERKEMBANGAN + add_url + id_kelas, { params })
  console.log('current state:', getState())
  return response.data
})

// ASPEK PERKEMBANGAN ANAK

export const putAspekPerkembanganNilai = createAsyncThunk('appNilaiAp/putAspekPerkembanganNilai', async (request, { dispatch, getState }) => {
  const add_url = "member/nilai"
  const response = await axios.put(stat.URL_ASPEK_PERKEMBANGAN + add_url, request.payload)
  await dispatch(getAspekPerkembanganMember(getState().nilaiap.idKelas))
  return response.data
})

export const putAspekPerkembanganKesehatan = createAsyncThunk('appNilaiAp/putAspekPerkembanganKesehatan', async (request, { dispatch, getState }) => {
  const add_url = "member/kesehatan"
  const response = await axios.put(stat.URL_ASPEK_PERKEMBANGAN + add_url, request.payload)
  await dispatch(getAspekPerkembanganMember(getState().nilaiap.idKelas))
  return response.data
})

export const appNilaiApSlice = createSlice({
  name: 'appNilaiAp',
  initialState: {
    grade: [],
    statusLoadGrade: null,
    kelas: [],
    idKelas: null,
    statusIdKelas: null,
    kodeGrade: null,
    siswa_nilai: null,
    statusAspekPerkembangan: null,
    responseAspekPerkembangan: null, 
    statusAspekPerkembanganMember: null,
    reseponsePerkembanganAnakNilai: null,

    statusPutAspekPerkembanganNilai: null, 
    // responsePutAspekPerkembanganNilai: null,

    statusPutAspekPerkembanganKesehatan: null, 
    // responsePutAspekPerkembanganKesehatan: null,
    // selectedTask: {},
    params: {
      filter: '',
      q: '',
      sort: '',
      tag: ''
    }
  },
  reducers: {
    selectIdKelas: (state, action) => {
      state.idKelas = action.payload
    },
    selectKodeGrade: (state, action) => {
      state.kodeGrade = action.payload
    },
    selectSiswa: (state, action) => {
      state.siswa_nilai = action.payload
    },
    stateReset: (state) => {
      state.statusAspekPerkembangan = null
      state.statusAspekPerkembanganMember = null
      state.statusPutAspekPerkembanganNilai = null
      state.statusPutAspekPerkembanganKesehatan = 'loading'
    }
    // stateResetTujuanPembelajaran: (state) => {
    //   state.statusPostTujuanPembelajaran = 'loading'
    //   state.statusPutTujuanPembelajaran = 'loading'
    //   state.statusDelTujuanPembelajaran = 'loading'
    // },
    // stateResetNilaiTujuanPembelajaran: (state) => {
    //   state.statusPutNilaiTujuanPembelajaran = 'loading'
    // },
    // stateResetNilaiLingkupMateri: (state) => {
    //   state.statusPutNilaiLingkupMateri = 'loading'
    // },
    // stateResetPelajaranNilai: (state) => {
    //   state.statusPutPelajaranNilai = 'loading'
    // }
    
  },
  extraReducers: builder => {
    
    builder.addCase(getGrade.fulfilled, (state, action) => {
      state.grade = action.payload.data
      state.params = action.payload.params
    })

    builder.addCase(getGradeKelas.pending, (state) => {
      state.statusIdKelas = 'loading'
    })
    builder.addCase(getGradeKelas.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      console.log("Full filled Kelas", action.payload.data)
      state.statusIdKelas = 'loaded'
      state.kelas = action.payload.data
      state.params = action.payload.params
    })
  

    builder.addCase(putAspekPerkembanganNilai.pending, (state) => {
      state.statusPutAspekPerkembanganNilai = 'loading'
    })
    builder.addCase(putAspekPerkembanganNilai.fulfilled, (state) => {
      state.statusPutAspekPerkembanganNilai = 'loaded'
      // state.reseponsePerkembanganAnakNilai = action.payload
    })
    builder.addCase(putAspekPerkembanganNilai.rejected, (state, action) => {
      state.statusPutAspekPerkembanganNilai = 'failed'
      state.reseponsePerkembanganAnakNilai = action.error
    })

    builder.addCase(putAspekPerkembanganKesehatan.pending, (state) => {
      state.statusPutAspekPerkembanganKesehatan = 'loading'
    })
    builder.addCase(putAspekPerkembanganKesehatan.fulfilled, (state) => {
      state.statusPutAspekPerkembanganKesehatan = 'loaded'
      // state.reseponsePerkembanganAnakNilai = action.payload
    })
    builder.addCase(putAspekPerkembanganKesehatan.rejected, (state, action) => {
      state.statusPutAspekPerkembanganKesehatan = 'failed'
      state.reseponsePerkembanganAnakNilai = action.error
    })
     // Get Aspek Perkembangan
    // ==========================================================

    builder.addCase(getAspekPerkembangan.pending, (state) => {
      state.statusAspekPerkembangan = 'loading'
    })
    builder.addCase(getAspekPerkembangan.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      state.statusAspekPerkembangan = 'loaded'
      state.responseAspekPerkembangan = action.payload.data
    })
    builder.addCase(getAspekPerkembangan.rejected, (state, action) => {
      state.statusAspekPerkembangan = 'failed'
      state.responseAspekPerkembangan = action.error
    })

  
    // Get Member
    // ==========================================================

    builder.addCase(getAspekPerkembanganMember.pending, (state) => {
      state.statusAspekPerkembanganMember = 'loading'
    })
    builder.addCase(getAspekPerkembanganMember.fulfilled, (state, action) => {
      console.log("loaded aspek perkembangan member", action.payload.data)
      state.statusAspekPerkembanganMember = 'loaded'
      state.reseponsePerkembanganAnakNilai = action.payload.data
    })
    builder.addCase(getAspekPerkembanganMember.rejected, (state, action) => {
      state.statusAspekPerkembanganMember = 'failed'
      state.reseponsePerkembanganAnakNilai = action.error
    })
   
    
  }
})

export const { selectIdKelas, selectKodeGrade, selectSiswa, stateReset } = appNilaiApSlice.actions

export default appNilaiApSlice.reducer
